define(function(require) {
  var IpsModelCollection = require('civicsBase/ipsModelCollection');
  const favorite_service_request_type_model = require('civicsModels/portal/favorite_service_request_type_model');

  return IpsModelCollection.extend({
    model: favorite_service_request_type_model,
    urlRoot: '/delegate/civics-api/api/portal/favorites/crm/servicerequesttypes/',
    url: function() {
      return this.urlRoot;
    }
  });
})
